import { ComposeFormStore } from 'owa-calendar-compose-types';
import { createStore } from 'satcheljs';

let composeFormStore: ComposeFormStore = {
    formId: null,
    openedForm: null,
    originalEvent: null,
    event: null,
    uiState: null,
    metricsInfo: null,
    attachmentFiles: null,
};

export const getLegacyComposeStore = createStore<ComposeFormStore>(
    'composeFormStoreLegacy',
    composeFormStore
);
